import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icons-analytics",
  "use": "icons-analytics-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" id=\"icons-analytics\"><polygon fill=\"currentColor\" points=\"18 16 18 21 17 21 17 9 13 9 13 21 12 21 12 6 8 6 8 21 7 21 7 14 3 14 3 3 2 3 2 22 3 22 7 22 8 22 12 22 13 22 17 22 18 22 22 22 22 21 22 16 18 16\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol